export const authenticate = 'AUTHENTICATE_USER';
export const loggedIn = 'USER_LOGGED_IN';
export const unAuthenticate = 'UNAUTHENTICATE_USER';
